import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M1.381 22.628l1.5-5.454A10.49 10.49 0 014.569 4.467a10.615 10.615 0 0112.765-1.669 10.544 10.544 0 014.48 5.09 10.486 10.486 0 01.445 6.753 10.527 10.527 0 01-3.777 5.628 10.607 10.607 0 01-11.49.895l-5.61 1.464z",
      fill: "#5AD265"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M1 23l1.554-5.65A10.866 10.866 0 014.306 4.189a10.995 10.995 0 0113.222-1.725 10.921 10.921 0 014.64 5.272 10.861 10.861 0 01.458 6.994c-.624 2.319-2 4.367-3.912 5.828a10.986 10.986 0 01-11.901.925L1 23zm6.076-3.488l.332.197a9.132 9.132 0 004.634 1.264 9.135 9.135 0 005.58-1.896 9.066 9.066 0 003.246-4.901 9.032 9.032 0 00-.45-5.854A9.083 9.083 0 0016.46 3.97 9.143 9.143 0 005.434 5.671a9.036 9.036 0 00-1.099 11.055l.216.342-.92 3.348 3.445-.904z",
      fill: "url(#logo_svg__paint0_linear_660_79451)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.306 7.339c-.205-.454-.42-.463-.617-.472h-.524a1.011 1.011 0 00-.73.34 3.057 3.057 0 00-.957 2.273c0 1.341.98 2.637 1.12 2.819.141.18 1.894 3.021 4.677 4.112 2.312.909 2.782.729 3.283.683.502-.047 1.62-.659 1.849-1.295.228-.636.228-1.182.16-1.296-.07-.115-.251-.182-.526-.318-.275-.137-1.619-.796-1.87-.886-.25-.09-.434-.14-.616.14-.182.278-.7.885-.866 1.067-.165.181-.32.205-.593.068a7.48 7.48 0 01-2.201-1.352 8.205 8.205 0 01-1.523-1.888c-.16-.279-.017-.418.12-.558.137-.14.28-.318.41-.477.113-.137.205-.29.274-.455a.498.498 0 00-.03-.484c-.063-.14-.594-1.483-.84-2.021z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "linearGradient",
    {
      id: "logo_svg__paint0_linear_660_79451",
      x1: 12,
      y1: 23,
      x2: 12,
      y2: 0.999,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ e.createElement("stop", { stopColor: "#fff" }),
    /* @__PURE__ */ e.createElement("stop", { offset: 1, stopColor: "#fff" })
  ))
), a = t;
export {
  a as default
};
